/**
 * DIAGNOSTIC DRUPAL URL DECLARATION
 */
const CMS_BASE_URL = process.env.NEXT_PUBLIC_CMS_BASE_URL;

/**
 * HOME -> gives widget data returned by v1 /getWidgets API, used on homepage
 * DETAILS -> gives diagnosticWidgetData returned by v1 /diagnostic-details API
 * CART -> gives widget_data returned by v1 /cart-items API
 *
 * v2 of /diagnostic-details & /cart-items APIs do not return widget data, hence
 * all occurences of these APIs requiring widget data should be replaced
 * with call to /getWidgets API with proper page key
 */
export enum GET_WIDGETS_PAGE_KEYS {
  HOME = "Home",
  DETAILS = "Details",
  CART = "Cart",
}

export const DIAGNOSTIC_DETAIL_DATA_DRUPAL_ITEMID_URL = `${CMS_BASE_URL}/api/v2/diagnostic-details`;
export const DIAGNOSTIC_DETAIL_DATA_DRUPAL_CANONICALTAG_URL = `${CMS_BASE_URL}/api/v2/diagnostic-details/99999?ctag=`;
export const DIAGNOSTIC_LANDING_PAGE_DATA_URL = `${CMS_BASE_URL}/api/v2/diagnostic/getwidgets`;
export const DIAGNOSTIC_LANDING_PAGE_BANNERS_URL = `${CMS_BASE_URL}/api/banner/diagnostic`;
export const DIAGNOSTIC_DRUPAL_CART_ITEM_URL = `${CMS_BASE_URL}/api/v2/diagnostic/cart-items`;
export const DIAGNOSTIC_DRUPAL_ITEM_LIST_URL = `${CMS_BASE_URL}/api/v2/diagnostic-list`;
export const DIAGNOSTIC_DOCTOR_ITEM_SEARCH_URL = `${CMS_BASE_URL}/api/diagnostic/diagnosticdoctoritemsearch`;
export const DIAGNOSTIC_LISTINGPAGE_URL = `${CMS_BASE_URL}/api/diagnostic/getlistingpages`;
export const DIABETES_MANAGEMENT_ARTICLE_URL = `${CMS_BASE_URL}/api/articlelist-new?catid=diabetes-management&limit=50`;

export const getWidgetsUrlForPage = (
  cityId: number,
  page: GET_WIDGETS_PAGE_KEYS = GET_WIDGETS_PAGE_KEYS.HOME
) => `${DIAGNOSTIC_LANDING_PAGE_DATA_URL}?city=${cityId}&page=${page}`;

export const getWidgetUrlForDiagnosticListingPage = (
  cityId: number,
  slugName: string
) => `${DIAGNOSTIC_LISTINGPAGE_URL}?slug=${slugName}&city=${cityId}`;
